module.exports = __webpack_public_path__ + "img/map-mongolia.68dedc11.png";